// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconMail } from '@tabler/icons-react';

const mamessagerie = {
    id: 'ma-messagerie',
    title: <FormattedMessage id="ma-messagerie" />,
    icon: IconMail,
    type: 'group',
    url: '/ui/ma-messagerie'
};

export default mamessagerie;
